import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CartService } from '../services/cart.service';
import { OrderService } from '../services/order.service';
import { ToastService } from '../toast.service';

@Component({
  selector: 'app-payment-success',
  templateUrl: './payment-success.component.html',
  styleUrls: ['./payment-success.component.css']
})
export class PaymentSuccessComponent implements OnInit {

  orderId!: number;

  constructor(
    private route: ActivatedRoute,
    private orderService: OrderService,
    private cartService: CartService,
    private toast: ToastService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.orderId = Number(this.route.snapshot.paramMap.get('orderId'));

    this.confirmOrder();
  }

  confirmOrder() {
    this.orderService.markOrderPaid(this.orderId).subscribe({
      next: () => {
        this.cartService.clearCart();
        this.toast.show('Payment successful! Order confirmed.', 'success');
        this.router.navigate(['/order-confirmation', this.orderId]);
      },
      error: () => {
        this.toast.show('Payment was successful but order update failed!', 'error');
      }
    });
  }
}
